import React from 'react'
import { TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField/TextField'

type ITextFieldComponentProps = TextFieldProps & {
  variant?: 'outlined' | 'filled' | 'standard'
}

export enum TextFieldType {
  text = 'text',
  number = 'number',
  password = 'password',
}

export type TextFieldSettings = {
  variant: 'outlined' | 'filled' | 'standard'
  type: TextFieldType
  margin: 'dense' | 'none' | 'normal'
  size: 'small' | 'medium'
}

const defaultSettings: TextFieldSettings = {
  variant: 'outlined',
  type: TextFieldType.text,
  margin: 'dense',
  size: 'medium',
}

const TextFieldComponent = React.forwardRef<HTMLDivElement, ITextFieldComponentProps>((props, ref) => {
  const variant = props.variant ? props.variant : defaultSettings.variant
  const type = props.type ? props.type : defaultSettings.type
  const size = props.size ? props.size : defaultSettings.size
  const margin = props.margin ? props.margin : defaultSettings.margin

  return (
    <TextField
      {... props}
      ref={ref}
      InputLabelProps={{
        shrink: true,
      }}
      variant={variant}
      margin={margin}
      type={type}
      size={size}
    />
  )
})

// needed for debugging and hot-reload functionality
TextFieldComponent.displayName = 'TextFieldComponent'
export default TextFieldComponent
